<template>
  <div
    class="min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-950/20 dark:to-emerald-950/20"
  >
    <div
      class="w-full max-w-md text-center bg-white dark:bg-gray-900 rounded-2xl shadow-lg border border-gray-200 dark:border-gray-700"
    >
      <!-- Header -->
      <div class="pb-4 px-6 pt-6">
        <div
          class="mx-auto mb-4 w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center"
        >
          <CheckCircle class="w-8 h-8 text-green-600 dark:text-green-400" />
        </div>
        <h2 class="text-2xl font-bold text-green-700 dark:text-green-300">
          Transport Voucher Saved!
        </h2>
        <p class="text-base text-gray-600 dark:text-gray-400">
          Your transport voucher has been successfully saved. You can now return to the job
          details to continue your work.
        </p>
      </div>

      <!-- Content -->
      <div class="px-6 pb-6 space-y-4">
        <div class="p-4 bg-green-50 dark:bg-green-900/20 rounded-lg">
          <p class="text-sm text-green-700 dark:text-green-300">
            A copy of the voucher has been recorded in the system. The admin will review or download it later from the job page.
          </p>
        </div>

        <button
          @click="goJobPage"
          class="w-full inline-flex items-center justify-center px-4 py-3 rounded-lg bg-green-600 text-white hover:bg-green-700 transition font-medium"
        >
          <ArrowLeft class="w-4 h-4 mr-2" />
          Return to Job
        </button>
      </div>
    </div>
  </div>
</template>


<script>
import { CheckCircle, ArrowLeft } from "lucide-vue-next";

export default {
  name: "VoucherSaved",
  components: { CheckCircle, ArrowLeft },
  methods: {
    goJobPage() {
      const voucherId = this.$route.params.jobId
      const jobId = voucherId.split('-').slice(0, 3).join('-')

      const token = this.$route.params.token

      if (jobId) {
        this.$router.push(`/jobstartend/${jobId}/${token}`)
      } else {
        this.$router.push("/login")
      }
    },
  },
};
</script>
